<admin-app-header></admin-app-header>
<app-enterprise-admin-bar></app-enterprise-admin-bar>

<div class="reporting-page">
    <div class="container-fluid">
        <!-- Date Range Filter -->
        <div class="filter-card">
            <form class="filter-form" [formGroup]="filterForm">
                <div class="filter-group">
                    <select class="form-select" formControlName="filterDateRange">
                        <option *ngFor="let option of dateRangeOptions" [value]="option.value">{{ option.label }}</option>
                    </select>
                </div>

                <!-- Custom Date Range Pickers -->
                <div class="filter-group" *ngIf="isCustomDateRange">
                    <input type="date" class="form-control" formControlName="customStartDate" placeholder="Start date" />
                </div>

                <div class="filter-group" *ngIf="isCustomDateRange">
                    <input type="date" class="form-control" formControlName="customEndDate" placeholder="End date" />
                </div>

                <!-- Campaign filters - hidden for Enterprise Managers who don't have access to global campaigns -->
                <ng-container *ngIf="!enterpriseContext.isEnterpriseManager">
                    <div class="filter-group">
                        <select class="form-select" formControlName="filterSource">
                            <option value="">Any Source</option>
                            <option *ngFor="let source of campaignSources.slice(1)" [value]="source">{{ source }}</option>
                        </select>
                    </div>

                    <div class="filter-group">
                        <select class="form-select" formControlName="filterCampaign">
                            <option value="">Any Campaign</option>
                            <option *ngFor="let campaign of filteredCampaigns" [value]="campaign.campaignName">{{ campaign.campaignName }}</option>
                        </select>
                    </div>
                </ng-container>

                <button type="button" class="clear-filters-btn" (click)="clearFilters()" title="Clear all filters">
                    <i class="fa-solid fa-xmark"></i>
                </button>
            </form>
        </div>
    </div>

    <!-- Metrics Display -->
    <div class="container-fluid" *ngIf="!loading">
        <!-- Primary Stats Row - 5 Main KPIs -->
        <div class="primary-stats-grid">
            <!-- Unique Visitors (not clickable) -->
            <div class="stat-card stat-card--visitors">
                <div class="stat-card__icon">
                    <i class="fa-solid fa-users"></i>
                </div>
                <div class="stat-card__content">
                    <span class="stat-card__value">{{ uniqueVisitors | number }}</span>
                    <span class="stat-card__label">Unique Visitors</span>
                    <span class="stat-card__subtext">{{ pageViews | number }} page views</span>
                </div>
            </div>

            <!-- Users with Profile (clickable -> CRM) -->
            <a [routerLink]="['/admin/crm/parker']" class="stat-card stat-card--profiles stat-card--clickable">
                <div class="stat-card__icon">
                    <i class="fa-solid fa-user-check"></i>
                </div>
                <div class="stat-card__content">
                    <span class="stat-card__value">{{ usersWithProfile | number }}</span>
                    <span class="stat-card__label">Users with Profile</span>
                    <span class="stat-card__subtext">of {{ totalUsers | number }} authenticated</span>
                </div>
            </a>

            <!-- Parkers (clickable -> CRM with filter) -->
            <a [routerLink]="['/admin/crm/parker']" [queryParams]="{ hasSubscription: 'true' }" class="stat-card stat-card--parkers stat-card--clickable">
                <div class="stat-card__icon">
                    <i class="fa-solid fa-car"></i>
                </div>
                <div class="stat-card__content">
                    <span class="stat-card__value">{{ parkers | number }}</span>
                    <span class="stat-card__label">Parkers</span>
                    <span class="stat-card__subtext">active or completed</span>
                </div>
            </a>

            <!-- New Subscriptions (clickable -> Subscriptions) -->
            <a [routerLink]="['/admin/subscriptions']" class="stat-card stat-card--subscriptions stat-card--clickable">
                <div class="stat-card__icon">
                    <i class="fa-solid fa-file-signature"></i>
                </div>
                <div class="stat-card__content">
                    <span class="stat-card__value">{{ newSubscriptions | number }}</span>
                    <span class="stat-card__label">New Subscriptions</span>
                    <span class="stat-card__subtext">{{ newSubscriptionsBays | number }} bays booked</span>
                </div>
            </a>

            <!-- Subscription Value (clickable -> Subscriptions) -->
            <a [routerLink]="['/admin/subscriptions']" class="stat-card stat-card--value stat-card--clickable">
                <div class="stat-card__icon">
                    <i class="fa-solid fa-coins"></i>
                </div>
                <div class="stat-card__content">
                    <span class="stat-card__value">{{ newSubscriptionsTotalContractValue | currency: 'R':'symbol':'1.0-0' }}</span>
                    <span class="stat-card__label">Subscription Value</span>
                    <span class="stat-card__subtext">total contract value</span>
                </div>
            </a>
        </div>

        <!-- Secondary Stat Cards Row - Less Emphasized -->
        <div class="tertiary-stats-grid">
            <!-- Expired (clickable -> Subscriptions with expired filter) -->
            <a [routerLink]="['/admin/subscriptions']" [queryParams]="{ status: 'Expired' }" class="stat-card-mini stat-card-mini--expired stat-card-mini--clickable">
                <div class="stat-card-mini__icon">
                    <i class="fa-solid fa-clock"></i>
                </div>
                <div class="stat-card-mini__content">
                    <span class="stat-card-mini__value">{{ expiredSubscriptions | number }}</span>
                    <span class="stat-card-mini__label">Expired</span>
                </div>
            </a>

            <!-- Rejected (clickable -> Rejections page) -->
            <a [routerLink]="['/admin/rejections']" class="stat-card-mini stat-card-mini--rejected stat-card-mini--clickable">
                <div class="stat-card-mini__icon">
                    <i class="fa-solid fa-ban"></i>
                </div>
                <div class="stat-card-mini__content">
                    <span class="stat-card-mini__value">{{ rejectedSubscriptions | number }}</span>
                    <span class="stat-card-mini__label">Rejected</span>
                </div>
            </a>

            <!-- New Buildings (clickable -> Parkings) -->
            <a [routerLink]="['/admin/parkings']" class="stat-card-mini stat-card-mini--neutral stat-card-mini--clickable">
                <div class="stat-card-mini__icon">
                    <i class="fa-solid fa-building"></i>
                </div>
                <div class="stat-card-mini__content">
                    <span class="stat-card-mini__value">{{ newParkingBuildings | number }}</span>
                    <span class="stat-card-mini__label">New Buildings</span>
                </div>
            </a>

            <!-- New Bays -->
            <div class="stat-card-mini stat-card-mini--neutral">
                <div class="stat-card-mini__icon">
                    <i class="fa-solid fa-square-parking"></i>
                </div>
                <div class="stat-card-mini__content">
                    <span class="stat-card-mini__value">{{ newParkingBays | number }}</span>
                    <span class="stat-card-mini__label">New Bays</span>
                </div>
            </div>

            <!-- Total Invoiced -->
            <a [routerLink]="['/admin/invoices']" class="stat-card-mini stat-card-mini--neutral stat-card-mini--clickable">
                <div class="stat-card-mini__icon">
                    <i class="fa-solid fa-file-invoice"></i>
                </div>
                <div class="stat-card-mini__content">
                    <span class="stat-card-mini__value">{{ formatCurrency(totalInvoicesAmount) }}</span>
                    <span class="stat-card-mini__label">Invoiced</span>
                </div>
            </a>

            <!-- Total Paid -->
            <a [routerLink]="['/admin/invoices']" [queryParams]="{ status: 'paid' }" class="stat-card-mini stat-card-mini--success stat-card-mini--clickable">
                <div class="stat-card-mini__icon">
                    <i class="fa-solid fa-check-circle"></i>
                </div>
                <div class="stat-card-mini__content">
                    <span class="stat-card-mini__value">{{ formatCurrency(totalInvoicesPaid) }}</span>
                    <span class="stat-card-mini__label">Paid</span>
                </div>
            </a>

            <!-- Total Paid Out -->
            <a [routerLink]="['/admin/payouts']" class="stat-card-mini stat-card-mini--success stat-card-mini--clickable">
                <div class="stat-card-mini__icon">
                    <i class="fa-solid fa-money-bill-transfer"></i>
                </div>
                <div class="stat-card-mini__content">
                    <span class="stat-card-mini__value">{{ formatCurrency(totalPaidOutAmount) }}</span>
                    <span class="stat-card-mini__label">Paid Out</span>
                </div>
            </a>

            <!-- More Data (opens modal) -->
            <div class="stat-card-mini stat-card-mini--muted stat-card-mini--clickable" (click)="openMoreDataModal()">
                <div class="stat-card-mini__icon">
                    <i class="fa-solid fa-chart-bar"></i>
                </div>
                <div class="stat-card-mini__content">
                    <span class="stat-card-mini__value"><i class="fa-solid fa-arrow-up-right-from-square"></i></span>
                    <span class="stat-card-mini__label">More Data</span>
                </div>
            </div>
        </div>

        <!-- Metrics Tabs Section -->
        <hr class="section-divider" />
        
        <!-- Tab Navigation -->
        <ul class="nav nav-tabs mb-4">
            <li class="nav-item">
                <a class="nav-link" [class.active]="activeMetricsTab === 'current'" (click)="selectMetricsTab('current')" style="cursor: pointer">
                    <i class="fa-solid fa-bolt me-2"></i>Current Metrics
                </a>
            </li>
            <li class="nav-item">
                <a class="nav-link" [class.active]="activeMetricsTab === 'alltime'" (click)="selectMetricsTab('alltime')" style="cursor: pointer">
                    <i class="fa-solid fa-infinity me-2"></i>All-Time Metrics
                </a>
            </li>
        </ul>

        <!-- Current Metrics Tab Content -->
        <div class="current-section" *ngIf="activeMetricsTab === 'current'">
            <p class="section-subtitle">Live status of active subscriptions</p>

            <!-- Loading spinner for current metrics -->
            <div *ngIf="loadingCurrentMetrics" class="text-center py-4">
                <div class="spinner-border text-primary" role="status">
                    <span class="visually-hidden">Loading...</span>
                </div>
                <p class="mt-2 text-muted">Loading current metrics...</p>
            </div>

            <div class="all-time-stats-grid-compact" *ngIf="!loadingCurrentMetrics">
                <!-- Active Subscriptions -->
                <a [routerLink]="['/admin/subscriptions']" [queryParams]="{ status: 'Active' }" class="all-time-card-compact all-time-card-compact--active all-time-card-compact--clickable">
                    <div class="all-time-card-compact__icon">
                        <i class="fa-solid fa-file-signature"></i>
                    </div>
                    <div class="all-time-card-compact__content">
                        <span class="all-time-card-compact__value">{{ currentActiveSubscriptions | number }}</span>
                        <span class="all-time-card-compact__label">Active Subs</span>
                    </div>
                </a>

                <!-- Active Bays -->
                <div class="all-time-card-compact all-time-card-compact--active">
                    <div class="all-time-card-compact__icon">
                        <i class="fa-solid fa-square-parking"></i>
                    </div>
                    <div class="all-time-card-compact__content">
                        <span class="all-time-card-compact__value">{{ currentActiveBays | number }}</span>
                        <span class="all-time-card-compact__label">Active Bays</span>
                    </div>
                </div>

                <!-- Monthly Revenue -->
                <div class="all-time-card-compact all-time-card-compact--revenue">
                    <div class="all-time-card-compact__icon">
                        <i class="fa-solid fa-coins"></i>
                    </div>
                    <div class="all-time-card-compact__content">
                        <span class="all-time-card-compact__value">{{ formatCurrency(currentMonthlyRevenue) }}</span>
                        <span class="all-time-card-compact__label">Monthly Revenue</span>
                    </div>
                </div>

                <!-- Draft Subscriptions -->
                <a [routerLink]="['/admin/subscriptions']" [queryParams]="{ status: 'Incomplete' }" class="all-time-card-compact all-time-card-compact--draft all-time-card-compact--clickable">
                    <div class="all-time-card-compact__icon">
                        <i class="fa-solid fa-file-pen"></i>
                    </div>
                    <div class="all-time-card-compact__content">
                        <span class="all-time-card-compact__value">{{ currentDraftSubscriptions | number }}</span>
                        <span class="all-time-card-compact__label">Draft</span>
                    </div>
                </a>

                <!-- Pending Confirmation -->
                <a
                    [routerLink]="['/admin/subscriptions']"
                    [queryParams]="{ status: 'Pending Client Approval' }"
                    class="all-time-card-compact all-time-card-compact--pending all-time-card-compact--clickable"
                >
                    <div class="all-time-card-compact__icon">
                        <i class="fa-solid fa-hourglass-half"></i>
                    </div>
                    <div class="all-time-card-compact__content">
                        <span class="all-time-card-compact__value">{{ currentPendingConfirmationSubscriptions | number }}</span>
                        <span class="all-time-card-compact__label">Pending</span>
                    </div>
                </a>
            </div>
        </div>

        <!-- All-Time Metrics Tab Content -->
        <div class="all-time-section" *ngIf="activeMetricsTab === 'alltime'">
            <p class="section-subtitle">These metrics are not affected by the date range filter</p>

            <!-- Loading spinner for all-time metrics -->
            <div *ngIf="loadingAllTimeMetrics" class="text-center py-4">
                <div class="spinner-border text-primary" role="status">
                    <span class="visually-hidden">Loading...</span>
                </div>
                <p class="mt-2 text-muted">Loading all-time metrics...</p>
            </div>

            <div class="all-time-stats-grid-compact" *ngIf="!loadingAllTimeMetrics">
                <!-- Overdue Invoices (clickable -> Invoices with overdue filter) -->
                <a [routerLink]="['/admin/invoices']" [queryParams]="{ status: 'overdue' }" class="all-time-card-compact all-time-card-compact--warning all-time-card-compact--clickable">
                    <div class="all-time-card-compact__icon">
                        <i class="fa-solid fa-clock-rotate-left"></i>
                    </div>
                    <div class="all-time-card-compact__content">
                        <span class="all-time-card-compact__value">{{ formatCurrency(allTimeOverdueAmount) }}</span>
                        <span class="all-time-card-compact__label">Overdue Invoices</span>
                        <span class="all-time-card-compact__subcount">{{ allTimeOverdueInvoices }} invoices</span>
                    </div>
                </a>

                <!-- Not Paid Out (clickable -> Invoices with not paid out filter) -->
                <a [routerLink]="['/admin/invoice-payouts']" class="all-time-card-compact all-time-card-compact--info all-time-card-compact--clickable">
                    <div class="all-time-card-compact__icon">
                        <i class="fa-solid fa-hand-holding-dollar"></i>
                    </div>
                    <div class="all-time-card-compact__content">
                        <span class="all-time-card-compact__value">{{ formatCurrency(allTimeNotPaidOutAmount) }}</span>
                        <span class="all-time-card-compact__label">Not Paid Out</span>
                        <span class="all-time-card-compact__subcount">{{ allTimeNotPaidOut }} invoices</span>
                    </div>
                </a>

                <!-- Total Buildings (clickable -> Parkings) -->
                <a [routerLink]="['/admin/parkings']" class="all-time-card-compact all-time-card-compact--neutral all-time-card-compact--clickable">
                    <div class="all-time-card-compact__icon">
                        <i class="fa-solid fa-building"></i>
                    </div>
                    <div class="all-time-card-compact__content">
                        <span class="all-time-card-compact__value">{{ allTimeActiveBuildings | number }}</span>
                        <span class="all-time-card-compact__label">Total Buildings</span>
                    </div>
                </a>

                <!-- Total Bays -->
                <div class="all-time-card-compact all-time-card-compact--neutral">
                    <div class="all-time-card-compact__icon">
                        <i class="fa-solid fa-square-parking"></i>
                    </div>
                    <div class="all-time-card-compact__content">
                        <span class="all-time-card-compact__value">{{ formatNumber(allTimeActiveParkingBays) }}</span>
                        <span class="all-time-card-compact__label">Total Bays</span>
                    </div>
                </div>

                <!-- Total Subscriptions (clickable -> Subscriptions) -->
                <a [routerLink]="['/admin/subscriptions']" class="all-time-card-compact all-time-card-compact--neutral all-time-card-compact--clickable">
                    <div class="all-time-card-compact__icon">
                        <i class="fa-solid fa-file-contract"></i>
                    </div>
                    <div class="all-time-card-compact__content">
                        <span class="all-time-card-compact__value">{{ formatNumber(allTimeTotalSubscriptions) }}</span>
                        <span class="all-time-card-compact__label">Total Subscriptions</span>
                    </div>
                </a>

                <!-- Total Users (clickable -> CRM) -->
                <a [routerLink]="['/admin/crm/parker']" class="all-time-card-compact all-time-card-compact--neutral all-time-card-compact--clickable">
                    <div class="all-time-card-compact__icon">
                        <i class="fa-solid fa-users"></i>
                    </div>
                    <div class="all-time-card-compact__content">
                        <span class="all-time-card-compact__value">{{ formatNumber(allTimeTotalUsers) }}</span>
                        <span class="all-time-card-compact__label">Total Users</span>
                    </div>
                </a>
            </div>
        </div>
    </div>

    <!-- More Data Modal -->
    <div class="modal-overlay" *ngIf="showMoreDataModal" (click)="closeMoreDataModal()">
        <div class="modal-content" (click)="$event.stopPropagation()">
            <div class="modal-header">
                <h3>Detailed Metrics</h3>
                <button class="modal-close" (click)="closeMoreDataModal()">
                    <i class="fa-solid fa-xmark"></i>
                </button>
            </div>
            <div class="modal-body">
                <div class="modal-section">
                    <h4>Subscription Averages</h4>
                    <div class="modal-stat-row">
                        <span class="modal-stat-label">Avg. Bays per Subscription</span>
                        <span class="modal-stat-value">{{ averageBaysPerSubscription | number: '1.1-1' }}</span>
                    </div>
                    <div class="modal-stat-row">
                        <span class="modal-stat-label">Avg. Subscription Value</span>
                        <span class="modal-stat-value">{{ averageSubscriptionValue | currency: 'R':'symbol':'1.0-0' }}</span>
                    </div>
                    <div class="modal-stat-row">
                        <span class="modal-stat-label">Avg. Monthly Bay Price</span>
                        <span class="modal-stat-value">{{ averageMonthlyBayPrice | currency: 'R':'symbol':'1.0-0' }}</span>
                    </div>
                    <div class="modal-stat-row">
                        <span class="modal-stat-label">Avg. Contract Duration</span>
                        <span class="modal-stat-value">{{ averageMonthsDuration | number: '1.1-1' }} months</span>
                    </div>
                </div>
                <div class="modal-section">
                    <h4>Subscription Totals (New Subscriptions)</h4>
                    <div class="modal-stat-row">
                        <span class="modal-stat-label">New Bays Booked</span>
                        <span class="modal-stat-value">{{ newSubscriptionsBays | number }}</span>
                    </div>
                    <div class="modal-stat-row">
                        <span class="modal-stat-label">First Month Value</span>
                        <span class="modal-stat-value">{{ newSubscriptionsMonthlyFees | currency: 'R':'symbol':'1.0-0' }}</span>
                    </div>
                    <div class="modal-stat-row">
                        <span class="modal-stat-label">Total Contract Value</span>
                        <span class="modal-stat-value">{{ newSubscriptionsTotalContractValue | currency: 'R':'symbol':'1.0-0' }}</span>
                    </div>
                </div>
                <div class="modal-section">
                    <h4>All Subscriptions Totals</h4>
                    <div class="modal-stat-row">
                        <span class="modal-stat-label">Total Bays Booked</span>
                        <span class="modal-stat-value">{{ totalBaysBooked | number }}</span>
                    </div>
                    <div class="modal-stat-row">
                        <span class="modal-stat-label">Total Contract Value</span>
                        <span class="modal-stat-value">{{ totalContractValue | currency: 'R':'symbol':'1.0-0' }}</span>
                    </div>
                    <div class="modal-stat-row">
                        <span class="modal-stat-label">Total Monthly Fees</span>
                        <span class="modal-stat-value">{{ totalMonthlyFees | currency: 'R':'symbol':'1.0-0' }}</span>
                    </div>
                    <div class="modal-stat-row">
                        <span class="modal-stat-label">Total Months Duration</span>
                        <span class="modal-stat-value">{{ totalMonths | number }}</span>
                    </div>
                </div>
                <div class="modal-section">
                    <h4>Subscription Status Breakdown</h4>
                    <div class="modal-stat-row">
                        <span class="modal-stat-label">Active</span>
                        <span class="modal-stat-value">{{ activeSubscriptions | number }}</span>
                    </div>
                    <div class="modal-stat-row">
                        <span class="modal-stat-label">Completed</span>
                        <span class="modal-stat-value">{{ completedSubscriptions | number }}</span>
                    </div>
                    <div class="modal-stat-row">
                        <span class="modal-stat-label">Cancelled</span>
                        <span class="modal-stat-value">{{ cancelledSubscriptions | number }}</span>
                    </div>
                    <div class="modal-stat-row">
                        <span class="modal-stat-label">Breached</span>
                        <span class="modal-stat-value">{{ breachedSubscriptions | number }}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Loading State -->
    <div class="loading-container" *ngIf="loading">
        <div class="loading-spinner">
            <div class="spinner"></div>
            <p>Loading reporting data...</p>
        </div>
    </div>
</div>
